export default __webpack_public_path__ + "static/studio-963108da2ff818dc8a34874dc5290af4.png";